
export const RESPONSIVE_MOBILE_RESOLUTION = 768;
export const RESPONSIVE_TABLET_RESOLUTION = 1024;

export const INSTANCE_NAME = "WeVideo";
export const APP_VERSION = "kungfu";
export const HUB_VERSION = "2.1.0";
export const WEVIDEO_TESTING_URI = '';
export const AWSTEST_HOSTNAME = 'awstest.wevideo.com';
export const DEVTEST_HOSTNAME = 'dev.wevideo.com';
export const USE_STRIPE_SPLIT_FORM = false;

export const APP_HASH_PATH_ROUTE = '/cart';
export const APP_HASH_SYMBOL = "#";
export const APP_HASH_PATH_ROUTE_INDEX = APP_HASH_PATH_ROUTE + APP_HASH_SYMBOL;

//!Important: dont use "_" in the APP_HASH_PATH for the strings
export const APP_HASH_PATH = {
    SIGN_UP: 'signup',
    AUTH_PAGE: 'auth',
    PLANS_PAGE: 'plans',
    CHECKOUT_PAGE: 'checkout',
    CHECKOUT_PRIVACY_PAGE: 'checkout',
    PAYMENT_COMPLETED: 'payment-completed',
    PAYPAL_COMPLETED: 'paypalCompleted',
    FREE_ACCOUNT_COMPLETED: 'free-account-completed',
    EDU_TRIAL_ACCOUNT_COMPLETED: 'edutrial-account-completed',
    BIZ_TRIAL_ACCOUNT_COMPLETED: 'biztrial-account-completed',
    EMAIL_ACTIVATION: 'email-activation',
    ADDITIONAL_SEATS: 'additional-seats',
    ESSENTIALS: 'essentials',
    CANCEL_ESSENTIALS: 'cancel-essentials',
    CANCEL_TRIAL: 'cancel-trial',
    UPGRADES_DISABLED: 'upgrades-disabled',
    SEGMENTATION: 'segmentation'
};

export const HASH_SUB_PAGE_DELIMITER = '_';

export const CHECKOUT_PAGE_TYPE = {
    CHECKOUT_SUMMARY: HASH_SUB_PAGE_DELIMITER + 'summary',
    CHECKOUT_SINGLE_EXPORT: HASH_SUB_PAGE_DELIMITER + 'single_export',
};

export const APP_HASH_ROUTES = {
    SIGN_UP: APP_HASH_PATH_ROUTE_INDEX + APP_HASH_PATH.SIGN_UP,
    AUTH_PAGE: APP_HASH_PATH_ROUTE_INDEX + APP_HASH_PATH.AUTH_PAGE,
    PLANS_PAGE: APP_HASH_PATH_ROUTE_INDEX + APP_HASH_PATH.PLANS_PAGE,
    CHECKOUT_PAGE: APP_HASH_PATH_ROUTE_INDEX + APP_HASH_PATH.CHECKOUT_PAGE + CHECKOUT_PAGE_TYPE.CHECKOUT_SUMMARY,
    CHECKOUT_SINGLE_EXPORT: APP_HASH_PATH_ROUTE_INDEX + APP_HASH_PATH.CHECKOUT_PAGE + CHECKOUT_PAGE_TYPE.CHECKOUT_SINGLE_EXPORT,
    PAYMENT_COMPLETED: APP_HASH_PATH_ROUTE_INDEX + APP_HASH_PATH.PAYMENT_COMPLETED,
    SEGMENTATION_PAGE: APP_HASH_PATH_ROUTE_INDEX + APP_HASH_PATH.SEGMENTATION,

    FREE_ACCOUNT_COMPLETED: APP_HASH_PATH_ROUTE_INDEX + APP_HASH_PATH.FREE_ACCOUNT_COMPLETED,
    EDU_TRIAL_ACCOUNT_COMPLETED: APP_HASH_PATH_ROUTE_INDEX + APP_HASH_PATH.EDU_TRIAL_ACCOUNT_COMPLETED,
    BIZ_TRIAL_ACCOUNT_COMPLETED: APP_HASH_PATH_ROUTE_INDEX + APP_HASH_PATH.BIZ_TRIAL_ACCOUNT_COMPLETED,
    EMAIL_ACTIVATION: APP_HASH_PATH_ROUTE_INDEX + APP_HASH_PATH.EMAIL_ACTIVATION,
    UPGRADES_DISABLED: APP_HASH_PATH_ROUTE_INDEX + APP_HASH_PATH.UPGRADES_DISABLED
};

export const APP_BROWSER_ROUTES = {
    SEGMENTATION_PAGE_STEP1: APP_HASH_PATH_ROUTE + '/segment',
    SEGMENTATION_PAGE_STEP2: APP_HASH_PATH_ROUTE + '/edu-role',
    SEGMENTATION_PAGE_STEP3: APP_HASH_PATH_ROUTE + '/edu-grade',
    SEGMENTATION_PAGE_STEP4: APP_HASH_PATH_ROUTE + '/edu-school',
    SEGMENTATION_PAGE_STEP5: APP_HASH_PATH_ROUTE + '/use-case',
    CHECKOUT_SUMMARY_PAGE: APP_HASH_PATH_ROUTE + '/checkout_summary',
    INVALID_EMAIL_PAGE: APP_HASH_PATH_ROUTE + '/invalid-email',
    RCE_LANDING: APP_HASH_PATH_ROUTE + '/rce',
    PLANS_PAGE_BROWSER: APP_HASH_PATH_ROUTE + '/plans',
};

export const APP_ROUTES = {
    HOMEPAGE: '/',
    HUB_DASHBOARD: '/app#',
    PLANS_SIGN_UP: '/sign-up',
    PLANS_PAGE: '/plans',
    INVITE_PAGE: '/invite',
    INVITE_PAGE_SLASH: '/invite/',
};

export const PATH_NAME_WITHOUT_HASH = [APP_ROUTES.HOMEPAGE, APP_ROUTES.PLANS_SIGN_UP];

export const APP_EXTERNAL_URLS = {
    HUB: '/app',
    NOT_LOGGED_PLANS_PAGE: '/plans',
    SIGN_UP: '/signup',
    SIGN_IN: '/sign-in',
    LOG_OUT_URL: '/login?action=logout&marketplaceId=16409042',
    TERMS_OF_USE: '/terms-of-use',
    ACCOUNT_DASHBOARD: '/hub#account',
    EXPIRED_TRIAL: '/hub#expiredtrial',
    QUOTE: '/orders?seats=',
    RCE_EXIT_PAGE: '/api/4/rce/tokens',
    SUPPORT_PAGE: '/support',
    CLASSES_PAGE: '/class',
    DASH_PAGE: '/dash#dash',
    UPGRADE_HUB: '/hub'
};

export const WEVIDEO_PLANS = {
    FREE_PLAN: 'wv_free',
    POWER_PLAN_M: 'wv_single_1m',
    POWER_PLAN_Y: 'wv_single_12m',
    POWER_ESSENTIALS_PLAN_M: 'wv_single_plus_1m',
    POWER_ESSENTIALS_PLAN_Y: 'wv_single_plus_12m',
    UNLIMITED_PLAN_M: 'wv_unloct17_1m',
    UNLIMITED_PLAN_Y: 'wv_unloct17_12m',
    UNLIMITED_ESSENTIALS_PLAN_M: 'wv_unloct17_plus_1m',
    UNLIMITED_ESSENTIALS_PLAN_Y: 'wv_unloct17_plus_12m',
    PROFESSIONAL_PLAN_M: 'wv_bizindiv_1m',
    PROFESSIONAL_PLAN_Y: 'wv_bizindiv_12m',
    BUSINESS_PLAN_Y: 'wv_bizoct17_12m',
    BUSINESS_PLAN_M: 'wv_bizoct17_1m',
    BUSINESS_PLAN_TRIAL: 'wv_bizoct17_trial',
    FLEX_PLAN: 'wv_flex2',
    SINGLE_PLUS_PLAN: 'single_plus',
    EDUCATION_TRIAL: 'wv_edu_trial',
    PROFESSIONAL_TRIAL: 'wv_bizindiv_trial',
    EDUCATION_K12_PLAN_Y: 'wv_k12_12m',
    EDUCATION_TEACHER_PLAN_Y: 'wv_teacher_12m',
    UNLIMITED_PLAN_TRIAL: 'wv_unlimited_trial',
};

export const ACCEPTED_VIDEO_EXTENSIONS = ['mp4', 'gifv', 'webm'];

export const POST_MESSAGES = {
    CLOSE_IFRAME: 'close_iframe',
    CHECKOUT_COMPLETED_SUCCESS: 'checkout_completed_success',
    CHECKOUT_COMPLETED_FAILURE: 'checkout_completed_failure',
    PAYMENT_PROCESSOR_PAYPAL: 'payment_paypal',
    PAYMENT_PROCESSOR_CC: 'payment_credit_card',
    NAVIGATE_TO_DASHBOARD: 'navigate_to_dashboard',
    CLICKED_GET_STARTED: 'clicked_get_started',
    CLICKED_PRIVACY_LINK: 'clicked_privacy_link',
    CLICKED_CONFIRM_SINGLE_EXPORT: 'clicked_confirm_single_export',
    CHECKOUT_NAVIGATION: 'cart_navigation',
    CLICKED_BACK_TO_FREE: 'clicked_back_to_free',
    EMAIL_ACTIVATION: 'email_activation',
    CLOSE_CHECKOUT_MODAL: 'close_checkout_modal',
};

export const TRACKING_CONST = {
    CHECKOUT_SUMMARY_PAGE: "website_checkout_summary"
};

export const TRACKING_SEGMENTATION_LABEL = {
    TEST_NAME: '2020_06_segmentation_signup',
    LABEL: 'new_web_segmentation',
};

export const ACCOUNT_COUPON_REASON = {
    PENDING: "instancePending"
};

export const USER_PURPOSE =  {
    K12_TEACHER: "k12_teacher",
    HIGHERED_TEACHER: "highered_teacher",
    K12_STUDENT: "k12_student",
};

export const DEFAULT_TRIAL_DURATION = 14;
export const ACTIVE_PROMO_CAMPAIGN = ["2021-holiday-60a", "AlmostThere60", "2021-end-of-year-60", "2022-valentine-60", "2022-spring-60"];